import React from 'react';
import '../ErrorPage/error.css';

export const Error403 = () => {
  return (
    <div className="error-container">
      <div className="error-code">403</div>
      <div className="error-content">
        <div className="error-title">FORBIDDEN</div>
        <div className="error-description">Sorry, you don't have permission to view this page</div>
      </div>
    </div>
  );
};

